package shared.business.di

import org.koin.core.qualifier.named

internal val boostieBackendKtorClient = named("boostieBackendKtorClient")
